/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Leadership_Founder_RoleInputs */

const en_landing_leadership_founder_role = /** @type {(inputs: Landing_Leadership_Founder_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Founder`)
};

/**
* | output |
* | --- |
* | "Founder" |
*
* @param {Landing_Leadership_Founder_RoleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_leadership_founder_role = /** @type {((inputs?: Landing_Leadership_Founder_RoleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Leadership_Founder_RoleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_leadership_founder_role(inputs)
});